import { Stack, TextField } from "@mui/material";
import { HelperText, ReadOnlyField } from "./OtpPanelParts";

const EndNodePreset = ({ config, handleConfigChange }) => {
  const setVariables = Object.entries(config.set_variables || {});

  return (
    <Stack spacing={3}>
      <TextField
        multiline
        rows={2}
        label="Closing Message"
        value={config.closing_message || ""}
        onChange={(event) => handleConfigChange("closing_message", event.target.value)}
        helperText="Optional. Sent to the customer when the flow ends. Leave empty to send nothing."
      />
      <ReadOnlyField label="Then" value="End conversation" />
      {setVariables.length > 0 && (
        <Stack spacing={1}>
          {setVariables.map(([key, value]) => (
            <ReadOnlyField key={key} label="Sets" value={`${key} = ${value}`} />
          ))}
          <HelperText>
            Set before the conversation ends, so the closing message can use them.
          </HelperText>
        </Stack>
      )}
    </Stack>
  );
};

export default EndNodePreset;
